var BraintreeKount = (function (braintree, $) {

    var BraintreeKount = function (opts) {
        this.$created = new $.Deferred();
        this.instance = null;
        this.kountEnabled = false;

        $.extend(this, opts);
    };

    $.extend(BraintreeKount.prototype, {
        init: function (clientInstance) {
            var callback = $.proxy(this._callback, this, clientInstance);

            if (this.kountEnabled) {
                braintree.dataCollector.create({
                    client: clientInstance,
                    kount: true,
                    paypal: true
                }, callback);
            } else {
                window.app && window.app.NRNoticeError && window.app.NRNoticeError('Braintree Device Data Disabled');
                callback('kount is disabled');
            }
            return this.$created.promise();

        },
        _callback: function (clientInstance, createErr, instance) {
            if (createErr) {
                window.app && window.app.NRNoticeError && window.app.NRNoticeError('Braintree Device Data (init failed): ' + createErr);
            }
            else {
                this.instance = instance;
            }

            this.$created.resolve(clientInstance);
        },
        getDeviceData: function () {
            if (this.instance && !this.instance.deviceData) {
                window.app && window.app.NRNoticeError && window.app.NRNoticeError('Braintree Device Data is absent');
            }
            return (this.instance && this.instance.deviceData) || '';
        }
    });

    return BraintreeKount;
})(window.braintree, jQuery);